"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTh = fixTh;
function fixTh(tex) {
    return tex.replace(new RegExp("\\\\th(\\s+|$)", "g"), "\\text{th}$1");
}
